var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.bookMarksLoading)?_c('div',{staticClass:"collection-container"},[_c('userCard',{staticClass:"user-container"}),_c('tabContainer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }